module.exports = __webpack_public_path__ + "img/traffic.3c6c5992.png";